import React, { useState } from "react";
import css from "./style.module.css";

const Pagination = ({ totalPages, onPageChange }) => {
  const [currentPage, setCurrentPage] = useState(1);

  const handlePageChange = (page) => {
    setCurrentPage(page);
    onPageChange(page);
  };

  const renderPagination = () => {
    const pages = [];
    const maxButtons = 11; // Максимальное количество отображаемых кнопок

    if (totalPages <= maxButtons) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i);
      }
    } else {
      if (currentPage <= 6) {
        for (let i = 1; i <= maxButtons; i++) {
          pages.push(i);
        }
      } else {
        for (let i = currentPage - 5; i <= currentPage + 5; i++) {
          pages.push(i);
        }
      }
    }

    return pages.map((page, index) => (
      <button
        key={index}
        onClick={() => handlePageChange(page)}
        disabled={page === currentPage}
        className={`${css.pageButton} ${
          currentPage === page ? css.active : ""
        }`}
      >
        {page}
      </button>
    ));
  };

  return <div>{renderPagination()}</div>;
};

export default Pagination;
